import React from 'react';

import { CookiesProvider } from 'react-cookie';

import clsx from 'clsx';

import ErrorScreen from 'app/components/ErrorScreen/ErrorScreen';
import ProviderConfirm from 'app/components/ProviderConfirm/ProviderConfirm';
import ProviderCredentials from 'app/components/ProviderCredentials/ProviderCredentials';
import ProviderLookup from 'app/components/ProviderLookup/ProviderLookup';
import useBreakpoint from 'hooks/useBreakpoint/useBreakpoint';
import useMainDataManager from 'hooks/useMainDataManager/useMainDataManager';

import { useStyles } from './styles';

// @ts-ignore
export const AppContext = React.createContext();

export function Main() {
  const classes = useStyles();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === 'xs';

  const {
    confirmedProvider,
    loading,
    options,
    states,
    formStep,
    email,
    password,
    hasErrored,
    error,
    setStep,
    setConfirmedProvider,
    setStateRequest,
    setSearchStateSuccess,
    setSearchRequest,
    setSearchSuccess,
    setStateEmail,
    setStatePassword,
    submitForm,
    resetError,
  } = useMainDataManager();

  const data = {
    confirmedProvider,
    loading,
    options,
    states,
    email,
    password,
    hasErrored,
    error,
    setStep,
    setConfirmedProvider,
    setStateRequest,
    setSearchStateSuccess,
    setSearchRequest,
    setSearchSuccess,
    setStateEmail,
    setStatePassword,
    submitForm,
    resetError,
  };

  return (
    <CookiesProvider>
      <AppContext.Provider value={data}>
        {hasErrored ?
          <div className={clsx({[classes.rootMobile]: isMobile, [classes.root]: !isMobile})}>
            <ErrorScreen/>
          </div>
          :
          <div className={clsx({[classes.rootMobile]: isMobile, [classes.root]: !isMobile})}>
            {formStep === 1 && <ProviderLookup/>}
            {formStep === 2 && <ProviderCredentials/>}
            {formStep === 3 && <ProviderConfirm/>}
          </div>
        }
      </AppContext.Provider>
    </CookiesProvider>
  );
}
